import { requestWithToken } from '../../utilities/request';
const fieldPath = '/api/private/fields';

/**
 * 現場常駐社員・非常駐入退場者一覧取得API
 * @param {number} fieldId 現場ID
 * @param {object} param
 * */
const fetchSpotWorkerList = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: fieldPath.concat(`/${fieldId}/field_spot_worker_settings/list`),
    params: param,
  });
};

const registerResidents = (fieldId, user_ids) => {
  return requestWithToken({
    method: 'POST',
    url: fieldPath.concat(`/${fieldId}/field_spot_workers/resident_register`),
    data: { user_ids },
  });
};

const registerNonResident = (fieldId, param) => {
  return requestWithToken({
    method: 'POST',
    url: fieldPath.concat(
      `/${fieldId}/field_spot_workers/non_resident_register`
    ),
    data: param,
  });
};

const updateNonResident = (fieldId, spotWorkerId, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: fieldPath.concat(`/${fieldId}/spot_workers/${spotWorkerId}`),
    data: param,
  });
};

const changeStatus = (fieldId, fieldSpotWorkerId, status) => {
  return requestWithToken({
    method: 'PATCH',
    url: fieldPath.concat(
      `/${fieldId}/field_spot_workers/${fieldSpotWorkerId}/change_status`
    ),
    data: { block_flag: `${status.id}` },
  });
};

const deleteSpotWorkers = (fieldId, fieldSpotWorkerIds) => {
  return requestWithToken({
    method: 'DELETE',
    url: fieldPath.concat(`/${fieldId}/field_spot_workers/destroy_list`),
    data: { field_spot_worker_ids: fieldSpotWorkerIds },
  });
};

const updateFacePicture = param => {
  return requestWithToken({
    method: 'POST',
    url: '/api/private/spot_workers/face_image_upload',
    headers: { 'content-type': 'multipart/form-data' },
    data: param,
  });
};

const fetchSingle = (fieldId, fieldSpotWorkerId) => {
  return requestWithToken({
    method: 'GET',
    url: fieldPath.concat(
      `/${fieldId}/field_spot_workers/${fieldSpotWorkerId}`
    ),
  });
};

/**
 * 連携サービス関連のAPI群
 * */
export const SpotWorkersApi = {
  fetchSpotWorkerList,
  registerResidents,
  registerNonResident,
  changeStatus,
  deleteSpotWorkers,
  updateNonResident,
  updateFacePicture,
  fetchSingle,
};

export default SpotWorkersApi;



// WEBPACK FOOTER //
// ./src/services/spotWorkers/SpotWorkersApi.js